import "./mission-style.scss";

import { Typography } from "@mui/material";
import { isMobile } from "react-device-detect";

import { getRandomFontProps, getRandomGreen, getRandomSlogan } from "./mission-dictionary";

export function MissionPage() {
    return (
        <div
            style={{
                width: "100%",
                height: "100%",
                background: getRandomGreen(),
            }}
        >
            <Typography
                key={Math.random().toString()}
                variant={"h3"}
                style={{
                    color: "white",
                    padding: isMobile ? "1rem" : "2rem",
                    paddingRight: isMobile ? "1rem" : "4rem",
                    fontSize: isMobile ? "3rem" : "5rem",
                    top: "50%",
                    position: "absolute",
                    transform: "translate(0, -50%)",
                    paddingLeft: "min(6rem, 15%)",
                    animationName: "mission-fade-in",
                    animationDuration: "600ms",
                    animationDelay: "700ms",
                    animationFillMode: "both",
                    opacity: 0,

                    ...getRandomFontProps(),
                }}
            >
                {getRandomSlogan()}
            </Typography>
        </div>
    );
}
